import PropTypes from 'prop-types';
import React from 'react';

import useClassName from '../../../hooks/class-name';
import { InputWrapper } from './styled';
import MetaData from './metadata';
import Label from './label';

const Input = (props) => {
  const {
    prependedIcon,
    appendedIcon,
    errorMessage,
    defaultValue,
    placeholder,
    description,
    onChange,
    helpText,
    disabled,
    required,
    label,
    block,
    size,
    type,
    id
  } = props;

  const fieldWrapperClassName = useClassName([
    prependedIcon ? 'with-prepended-icon' : '',
    appendedIcon ? 'with-appended-icon' : '',
    'field-wrapper',
    size
  ]);

  const className = useClassName([
    block ? 'block' : '',
    props.className
  ]);

  return (
    <InputWrapper className={className}>
      <div className="main-wrapper">
        <Label description={description} required={required} label={label} id={id} />

        <div className={fieldWrapperClassName}>
          {prependedIcon && (
            <button className="prepended-icon" type="button">
              <span>
                <img src={prependedIcon} />
              </span>
            </button>
          )}

          <input
            defaultValue={defaultValue}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
            required={required}
            type={type}
            id={id}
          />
          
          {appendedIcon && (
            <button className="appended-icon" type="button">
              <span>
                <img src={appendedIcon} />
              </span>
            </button>
          )}
        </div>
      </div>
      
      <MetaData errorMessage={errorMessage} helpText={helpText} />
    </InputWrapper>
  );
};

Input.defaultProps = {
  onChange: () => null,
  prependedIcon: '',
  appendedIcon: '',
  defaultValue: '',
  errorMessage: '',
  placeholder: '',
  size: 'default',
  description: '',
  disabled: false,
  required: false,
  className: '',
  block: false,
  helpText: '',
  type: 'text',
  label: '',
  id: ''
};

Input.propTypes = {
  size: PropTypes.oneOf(['default', 'large', 'small']),
  type: PropTypes.oneOf(['text', 'email', 'number']),
  defaultValue: PropTypes.string,
  errorMessage: PropTypes.string,
  prependedIcon: PropTypes.node,
  placeholder: PropTypes.string,
  appendedIcon: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.node,
  helpText: PropTypes.node,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  block: PropTypes.bool,
  id: PropTypes.string,
};

export default Input;